// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"northstar-calibration","358":"qms-test-runtime"}[chunkId] || chunkId) + "." + {"135":"75bb8a58","358":"ffff8ef5","453":"03346f77"}[chunkId] + ".chunk.js";
};